import * as React from 'react'
import {useSelector} from 'react-redux'

import {Button} from '@ua/design-system/components/button'
import {Text} from '@ua/design-system/components/text'

import {
  selectAppKey,
  selectAppName,
  selectProjectId,
  selectProjectName,
  selectUrl,
} from '../selectors'

interface DetailsProps {
  setShowEditDetails: (val: boolean) => void
}

const Details: React.FC<DetailsProps> = ({setShowEditDetails}) => {
  const appName = useSelector(selectAppName)
  const url = useSelector(selectUrl)
  const appKey = useSelector(selectAppKey)
  const projectId = useSelector(selectProjectId)
  const projectName = useSelector(selectProjectName)

  const isWallet = typeof projectId !== 'undefined'

  return (
    <div className="u-border-sm u-border-radius-md u-pad-0 u-space-bottom-05 u-space-items-0">
      <div className="u-flex">
        <Text variant="bodyMedium" fontWeight="bold">
          Project name &nbsp;
        </Text>
        <Text variant="bodyMedium">{isWallet ? projectName : appName}</Text>
      </div>

      <div className="u-flex">
        <Text variant="bodyMedium" fontWeight="bold">
          Page URL &nbsp;
        </Text>
        <Text variant="bodyMedium">{url}</Text>
      </div>

      <div className="u-flex">
        <Text variant="bodyMedium" fontWeight="bold">
          {isWallet ? 'Wallet Project ID' : 'App key'} &nbsp;
        </Text>
        <Text variant="bodyMedium"> {isWallet ? projectId : appKey}</Text>
      </div>
      <Button
        variant="secondary"
        size="sm"
        onClick={() => setShowEditDetails(true)}
      >
        Edit details
      </Button>
    </div>
  )
}

export default Details
